import { render, staticRenderFns } from "./Ingenierie.vue?vue&type=template&id=3ac15c80&scoped=true&"
import script from "./Ingenierie.vue?vue&type=script&lang=js&"
export * from "./Ingenierie.vue?vue&type=script&lang=js&"
import style0 from "./Ingenierie.vue?vue&type=style&index=0&id=3ac15c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac15c80",
  null
  
)

export default component.exports